import { useOtrack } from '@core/compositions/Otrack'

export interface PullDeviceTrackInfo {
  [key: string]: boolean | undefined
  initConnectionSucceed: boolean
  connectSucceed: boolean
  enterPasswordSucceed?: boolean
}

const { track } = useOtrack()

const makeProxy = <T extends { [key: string]: boolean | undefined }>(trackInfo: T, eventId: string) => {
  let isTracked = false

  return new Proxy(trackInfo, {
    set(target, key, value: boolean) {
      if (isTracked) return true
      const result = Reflect.set(target, key, value)

      // 如果某一个环节失败了，或者每个环节都成功了，就提交埋点记录
      if (result && (!value || Object.values(target).every((isSucceed) => isSucceed))) {
        track({ eventId }, target)
        isTracked = true
      }

      return result
    },
  })
}

export const usePullUpDeviceTrack = (eventId: string) => {
  const trackInfo: PullDeviceTrackInfo = {
    initConnectionSucceed: false,
    connectSucceed: false,
  }

  return makeProxy(trackInfo, eventId)
}
